import { MemoEditDialogState, MemoType } from ".";
import { InDefCommonFlagType } from "../../../util/general-code/enums/general-codes";

export const MemoEditDialogInitialState: MemoEditDialogState = {
  pjtId: "",
  tcktTypeCd: "",
  tcktStsTypeCd: "",
  mmTxt: "",
  orgMmTxt: "",
  updateDateTime: "",
  targetIndex: "",
  memoType: MemoType.PROJECT,
  isShow: false,
  isEdited: true,
};
